module.exports = __webpack_public_path__ + "img/macbook-air.05fd1b7d.png";